import { Component, OnInit, inject } from '@angular/core'
import { Observable } from 'rxjs'

import {
  ApiKey,
  API_KEYS_MAX_KEYS,
  CreatedApiKey,
} from '@cyborg-monorepo/hunter/common'
import { DialogService } from '@hyperkit'

import { VerityEnvironmentService } from '../../../../../environments/verity-environment.service'
import { UserService } from '../../../shared/services/user.service'

import { APIKeyDialogComponent } from './api-key-dialog/api-key-dialog.component'

@Component({
  standalone: false,
  templateUrl: './api-keys.component.html',
  styleUrls: ['./api-keys.component.scss'],
})
export class ApiKeysComponent implements OnInit {
  private userService = inject(UserService)
  private dialogService = inject(DialogService)
  private verityEnvironmentService = inject(VerityEnvironmentService)

  public readonly apiDocUrl = `${this.verityEnvironmentService.apiUrl}/docs/`
  public readonly keyLimit: number = API_KEYS_MAX_KEYS

  public apiKeys$: Observable<{ keys: Array<ApiKey> }>

  public ngOnInit(): void {
    this.getKeys()
  }

  public getKeys(): void {
    this.apiKeys$ = this.userService.getApiKeys()
  }

  public onCreateKey(name: string): void {
    this.userService.createApiKey(name).subscribe((apiKey: CreatedApiKey) => {
      this.getKeys()

      this.dialogService.open(APIKeyDialogComponent, {
        data: { apiKey: apiKey.key, keyName: apiKey.name },
      })
    })
  }

  public onRemoveKey(keyId: string): void {
    this.userService.deleteApiKey(keyId).subscribe(() => this.getKeys())
  }
}
